import { createContext, useContext, useEffect, useState } from "react";
import { GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged, setPersistence, browserLocalPersistence } from "firebase/auth";
import { auth } from "../firebase";

const provider = new GoogleAuthProvider();
provider.addScope("https://www.googleapis.com/auth/drive.file");
provider.addScope("https://www.googleapis.com/auth/spreadsheets");

const AuthContext = createContext();

export const GoogleAuthProviderComponent = ({ children }) => {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // Login handler
  const signInWithGoogle = async () => {
    try {
      await setPersistence(auth, browserLocalPersistence);
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
      setAccessToken(result._tokenResponse.oauthAccessToken); // only available here!
    } catch (err) {
      console.error("Google sign-in failed", err);
    }
  };

  // Logout handler
  const logout = async () => {
    await signOut(auth);
    setUser(null);
    setAccessToken(null);
  };

  // Listen for Firebase user changes
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
      // accessToken is NOT available after refresh, must re-login to get token!
      setAccessToken(null);
    });
    return unsub;
  }, []);

  return (
    <AuthContext.Provider value={{ user, accessToken, signInWithGoogle, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
